module.exports = __webpack_public_path__ + "img/5.1.6b096250.png";